import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";
import RoleProtectedRoute from "../../router/RoleProtectedRoute";
import WorkHoursLayout from "./WorkHoursLayout";
import { MENU, WORK_HOURS_BASE, workHoursDefaultRoute } from "./config";

// Construye el árbol de rutas /work-hours desde la config de navegación, de
// modo que el sub-menú y las rutas nunca diverjan. Espeja los bloques de rutas
// de las otras mini-apps (una app, sub-menú plano) envuelto en
// RoleProtectedRoute.
const children: RouteObject[] = [
  { index: true, element: <Navigate to={workHoursDefaultRoute} replace /> },
  ...MENU.map((item) => ({ path: item.id, element: item.element })),
];

export const workHoursRoute: RouteObject = {
  path: WORK_HOURS_BASE,
  element: <RoleProtectedRoute restrictedRoles={["web_services"]} />,
  children: [
    {
      path: "",
      element: <WorkHoursLayout />,
      children,
    },
  ],
};
